import { IonButton } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';

import './Button.scss';
import { uiButtonClassNames } from './class-names';
import { UiButtonProps } from './types';

export const UiButton: React.FC<UiButtonProps> = ({
  children,
  onClick,
  size = 'medium',
  expand = 'block',
  type = 'button',
  color = 'primary',
  round = 'lg',
  disabled,
  className,
  slot,
  TEST_ID,
}) => {
  const classes = classNames(
    uiButtonClassNames.root,
    uiButtonClassNames.size(size),
    uiButtonClassNames.round(round),
    uiButtonClassNames.color(color),
    uiButtonClassNames.expand(expand),
    className,
  );

  return (
    <IonButton
      className={classes}
      onClick={onClick}
      type={type}
      disabled={disabled}
      data-testid={TEST_ID}
      {...(slot && { slot })}
    >
      {children}
    </IonButton>
  );
};
